import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './pages/ProtectedRoute';
import ApplicantList from './components/ApplicantList';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/login" element={<Login />} />
                
                <Route path="/admin" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute> }>
                    <Route path="applicants" element={<ApplicantList />} />
                </Route>
            </Routes>
        </Router>
    );
};

export default App;
